export default __webpack_public_path__ + "static/media/clock-ticks-time.c7794786.svg";